module.exports = __webpack_public_path__ + "static/media/program-antyplagiatowy-wrona-1.3f846a0d.webp";